import { SEOHead } from "../components/SEOHead";
import { STATIC_PAGES } from "../seo/pages";
import { PublicHeader } from "../components/PublicHeader";
import "../styles/PublicCommon.css";
import "./PrivacyPolicyPage.css";

export const PrivacyPolicyPage = () => {
  return (
    <>
      <SEOHead page={STATIC_PAGES.privacyPolicy} />

      <div className="public-page">
        <PublicHeader activePage="privacy-policy" />

        {/* メインコンテンツ */}
        <main id="main-content" role="main">
          {/* ページヘッダー */}
          <section className="page-header">
            <div className="page-header-overlay" />
            <div className="page-header-content">
              <h1 className="page-title">プライバシーポリシー</h1>
              <p className="page-subtitle">Privacy Policy</p>
            </div>
          </section>

          {/* 本文セクション */}
          <section className="policy-section">
            <div className="container-narrow">
              <div className="policy-content">
                <p className="policy-intro">
                  都建設株式会社（以下、「当社」といいます。）は、お客様の個人情報の保護を重要な責務と考え、
                  以下のとおりプライバシーポリシーを定め、適切に取り扱います。
                </p>

                <article className="policy-article">
                  <h2>1. 個人情報の定義</h2>
                  <p>
                    個人情報とは、個人情報保護法第2条第1項により定義された、生存する個人に関する情報であって、
                    当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別できるもの（他の情報と容易に照合することができ、
                    それにより特定の個人を識別することができることとなるものを含みます。）、もしくは個人識別符号が含まれる情報を指します。
                  </p>
                </article>

                <article className="policy-article">
                  <h2>2. 個人情報の収集方法</h2>
                  <p>
                    当社は、お客様が当社のサービスをご利用いただく際に、以下のような方法で個人情報を収集させていただく場合があります。
                  </p>
                  <ul>
                    <li>お問い合わせフォームからのお問い合わせ時</li>
                    <li>お見積もり依頼時</li>
                    <li>採用応募時</li>
                    <li>電話、FAX、メール、LINEでのお問い合わせ時</li>
                    <li>当ウェブサイトの閲覧時（アクセス情報。詳しくは「7. アクセス情報の取得と利用」をご覧ください）</li>
                  </ul>
                </article>

                <article className="policy-article">
                  <h2>3. 個人情報の利用目的</h2>
                  <p>当社は、収集した個人情報を以下の目的で利用いたします。</p>
                  <ul>
                    <li>お問い合わせへの対応</li>
                    <li>お見積もりの作成および提供</li>
                    <li>サービスの提供、維持、改善</li>
                    <li>採用選考</li>
                    <li>当ウェブサイトの利用状況の分析と改善、不正アクセス・攻撃の検知と防止</li>
                    <li>当社からのご案内、ご連絡</li>
                    <li>その他、上記利用目的に付随する目的</li>
                  </ul>
                </article>

                <article className="policy-article">
                  <h2>4. 個人情報の第三者提供</h2>
                  <p>
                    当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。
                  </p>
                  <ul>
                    <li>お客様の同意がある場合</li>
                    <li>法令に基づく場合</li>
                    <li>人の生命、身体または財産の保護のために必要がある場合であって、お客様の同意を得ることが困難である場合</li>
                    <li>その他、個人情報保護法その他の法令で認められる場合</li>
                  </ul>
                </article>

                <article className="policy-article">
                  <h2>5. 個人情報の管理</h2>
                  <p>
                    当社は、お客様の個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、
                    セキュリティシステムの維持・管理体制の整備等の必要な措置を講じます。
                  </p>
                </article>

                <article className="policy-article">
                  <h2>6. 個人情報の開示・訂正・削除</h2>
                  <p>
                    お客様は、当社に対し、個人情報保護法の定めるところにより、
                    ご自身の個人情報の開示、訂正、追加、削除および利用停止を請求することができます。
                    ご請求の際は、下記のお問い合わせ先までご連絡ください。
                  </p>
                </article>

                <article className="policy-article" id="access-data">
                  <h2>7. アクセス情報の取得と利用</h2>
                  <p>
                    当社は、当ウェブサイトの利用状況を把握して改善するため、また不正アクセスや攻撃を検知・防止するため、
                    以下の情報（以下「アクセス情報」といいます。）を取得します。
                  </p>
                  <ul>
                    <li>
                      <strong>取得する情報</strong>：IPアドレス、ブラウザ・端末の種類、閲覧したページと日時、参照元（直前に見ていたページ、
                      または検索サイトなどのドメイン名）、画面とページの大きさ、ページ内でクリック・タップした位置と、押したリンク・ボタンの種類と文字、
                      スクロールした量、お問い合わせフォームの送信の有無
                    </li>
                    <li>
                      <strong>取得方法</strong>：当ウェブサイトのページに組み込んだ当社のプログラムが、上記の情報を当社のサーバーに送信します。
                      外部の解析サービスには送信しません。また、アクセス情報の取得のためにCookie等をお客様の端末に保存することはありません。
                    </li>
                    <li>
                      <strong>取得しない情報</strong>：フォームに入力された内容は、アクセス情報としては取得しません（入力欄を押した位置のみ取得します）。
                    </li>
                    <li>
                      <strong>利用目的</strong>：当ウェブサイトの利用状況の把握・分析と改善、不正アクセス・攻撃の検知と防止
                    </li>
                    <li>
                      <strong>閲覧の区別</strong>：同じ方の閲覧かどうかは、IPアドレス・ブラウザの種類と日ごとに変わる乱数を組み合わせた番号で推定します。
                      この番号は日付が変わると別の番号になります。
                    </li>
                    <li>
                      <strong>保存期間</strong>：IPアドレスとブラウザの種類は90日、そのほかのアクセス情報は400日（約13か月）を過ぎたものから削除します。
                    </li>
                    <li>
                      <strong>閲覧できる者</strong>：当社のサーバー管理者に限ります。
                    </li>
                    <li>
                      <strong>記録の停止</strong>：ブラウザで「トラッキング拒否（Do Not Track）」または「Global Privacy Control」を有効にしている場合は、
                      アクセス情報を記録しません。
                    </li>
                  </ul>
                  <p>
                    アクセス情報からお客様個人を特定することは目的としていませんが、お問い合わせの日時などと照らし合わせることで
                    特定の個人を識別できる場合があります。その場合は、本ポリシーに従い個人情報として取り扱います。
                  </p>
                </article>

                <article className="policy-article" id="external">
                  <h2>8. 外部サービスへの情報の送信</h2>
                  <p>
                    当ウェブサイトは、表示のために以下の外部サービスを利用しています。該当するページを表示した際に、
                    お客様のIPアドレス、ブラウザの種類、表示中のページのURLなどが各サービスに送信されます。
                  </p>
                  <ul>
                    <li>
                      Google Fonts（Google LLC）：文字（フォント）の表示のため（すべてのページ）
                    </li>
                    <li>
                      Google マップ（Google LLC）：地図の表示のため（トップページ・会社概要）
                    </li>
                    <li>
                      LINE（LINEヤフー株式会社）：公式アカウントのQRコード画像の表示のため（LINEの案内を開いたとき）
                    </li>
                  </ul>
                  <p>
                    各社での情報の取扱いについては、
                    <a href="https://policies.google.com/privacy?hl=ja" target="_blank" rel="noopener noreferrer">Google のプライバシーポリシー</a>
                    、
                    <a href="https://www.lycorp.co.jp/ja/company/privacypolicy/" target="_blank" rel="noopener noreferrer">LINEヤフーのプライバシーポリシー</a>
                    をご確認ください。
                  </p>
                </article>

                <article className="policy-article">
                  <h2>9. Cookieの使用について</h2>
                  <p>
                    当社は、当ウェブサイトの一般公開ページでCookieを使用していません（アクセス情報の取得にも使用しません）。
                    ただし、上記8の外部サービスが独自にCookieを使用する場合があります。
                    Cookieとは、ウェブサイトがお客様の端末に一時的にデータを書き込んで保存させる仕組みで、
                    お客様はブラウザの設定によりCookieの受け取りを拒否することができます。
                  </p>
                </article>

                <article className="policy-article">
                  <h2>10. プライバシーポリシーの変更</h2>
                  <p>
                    当社は、法令の変更等に伴い、予告なく本プライバシーポリシーを変更することがあります。
                    変更後のプライバシーポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。
                  </p>
                </article>

                <article className="policy-article">
                  <h2>11. お問い合わせ先</h2>
                  <p>個人情報の取扱いに関するお問い合わせは、以下までご連絡ください。</p>
                  <div className="contact-info">
                    <p className="company-name">都建設株式会社</p>
                    <p>〒797-0015</p>
                    <p>愛媛県西予市宇和町卯之町1丁目432</p>
                    <p>
                      TEL: <a href="tel:0894-62-4511">0894-62-4511</a>
                    </p>
                    <p>受付時間：平日 9:00～17:00</p>
                  </div>
                </article>

                <p className="policy-date">制定日：2024年1月1日</p>
                <p className="policy-date">改定日：2026年10月31日（アクセス情報の取得、外部サービスへの送信について追記）</p>
              </div>
            </div>
          </section>
        </main>

        {/* フッター */}
        <footer className="public-footer" role="contentinfo">
          <div className="footer-content">
            <div className="footer-logo">
              <img
                src="/static/miyako-logo-small-white.png"
                srcSet="/static/miyako-logo-small-white.png 1x, /static/miyako-logo-2x-white.png 2x"
                alt="都建設株式会社"
                className="footer-logo-image"
                width={60}
                height={45}
              />
              <span className="footer-company-name">都建設株式会社</span>
            </div>

            <address className="footer-address-block">
              <a
                href="https://maps.google.com/?q=愛媛県西予市宇和町卯之町1丁目432"
                className="footer-address"
                target="_blank"
                rel="noopener noreferrer"
              >
                〒797-0015 愛媛県西予市宇和町卯之町1丁目432
              </a>

              <a href="tel:0894-62-4511" className="footer-phone">
                お電話：<span itemProp="telephone">0894-62-4511</span>
              </a>
            </address>

            <nav className="footer-nav" aria-label="フッターナビゲーション">
              <a href="/">ホーム</a>
              <a href="/about">会社概要</a>
              <a href="/services">業務内容</a>
              <a href="/works">施工実績</a>
              <a href="/recruit">採用情報</a>
              <a href="/contact">お問い合わせ</a>
            </nav>

            <p className="footer-copyright">
              <small>
                ©2024 都建設株式会社 Powered by{" "}
                <a href="#" target="_blank" rel="noopener noreferrer">
                  VERYWEBB
                </a>
              </small>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
